import { useEffect, useRef } from "react";
import { useCart } from "@kega/sps-core";

import { useLocation } from 'react-router-dom';

import { useStore } from 'react-redux';

import useUserId from "./useUserId";
import useCartRestoration from "./checkout/useCartRestoration";

const useCheckLockedCart = () => {
    const { fetchCart } = useCart();

    const { pathname } = useLocation();

    const getUserId = useUserId();
    const store = useStore();

    const { isRestorationInProgress } = useCartRestoration();
    const processedRef = useRef(false);

    useEffect(() => {
        processedRef.current = false;
    }, [pathname]);

    useEffect(() => {
        const checkAndUnlockCart = async () => {
            const { cart } = store.getState();

            if (processedRef.current) {
                return;
            }

            const unlockCard = async () => {

                try {
                    processedRef.current = true;
                    
                    await fetchCart('current');
                    
                } catch (error) {
                    console.log(error);
                }
            }

            // Only clear cart if we're not on checkout pages and cart has ongoing payment session
            // Also check if cart restoration is in progress
            if (!pathname.includes('checkout') && cart?.hasOngoingPaymentSession && !(await isRestorationInProgress())) {
                unlockCard();
            }
        };

        checkAndUnlockCart();
        
    }, [pathname, isRestorationInProgress]);
    
    return null;
}

export default useCheckLockedCart;
